import { FC, PropsWithChildren } from "react";
import styles from "./Page.module.scss";
import { Header } from "@kaladel/react/Components";

interface PageProps {
    title: React.ReactNode;
    right?: React.ReactNode;
}

export const Page: FC<PropsWithChildren<PageProps>> = (props) => {
    return (
        <div>
            <div className={styles.title}>
                <Header title={props.title} right={props.right} />
            </div>
            <div className={styles.content}>
                {props.children}
            </div>
        </div>
    );
};